import { BeneficiaryFilterAllTypes } from '@repo/shared/dtos/beneficiary'
import { useT } from '@repo/ui/hooks'
import { forwardRef } from 'react'

import { OptionalsCrushed } from '@/components/beneficiary/list/filters/types'

const FilterLabel = forwardRef<
  HTMLDivElement,
  {
    filter: BeneficiaryFilterAllTypes
    label: string
  } & OptionalsCrushed
>(({ label, filter, optionalsCrushed }, _ref) => {
  const { t } = useT({ keyPrefix: 'beneficiary.filters' })
  return (
    <div className="flex items-center space-x-1 text-sm">
      <span className="font-medium">{label}</span>
      <span>{optionalsCrushed?.operator ?? t(`operators.${filter.operator}`)}</span>
      <span className="font-medium">
        {optionalsCrushed?.value ?? ('value' in filter ? filter.value : '')}
      </span>

      {filter.operator === 'between' && (
        <span className="space-x-1">
          <span>{t('operators.and')}</span>
          <span className="font-medium">{optionalsCrushed?.otherValue ?? filter.otherValue}</span>
        </span>
      )}
    </div>
  )
})

export default FilterLabel
